@if (sessionExpired()) {
<section
  class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white px-6 text-center"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="mb-4 h-14 w-14 text-red-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="1.5"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 9v3.75m0 3.75h.008v.008H12v-.008zM10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
    />
  </svg>
  <h2 class="mb-2 text-lg font-semibold text-gray-800">Sesión expirada</h2>
  <p>No pudimos renovar tu token. Intenta nuevamente.</p>
  <button type="button" (click)="retryTokenRefresh()">Reintentar</button>
</section>
} @else if (!hasToken()) {
<section
  class="fixed inset-0 z-40 flex flex-col items-center justify-center bg-white px-6 text-center"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="mb-4 h-14 w-14 animate-spin text-gray-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="1.5"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M21 12a9 9 0 11-6.219-8.56"
    />
  </svg>
  <h2 class="mb-2 text-lg font-semibold text-gray-800">Cargando token</h2>
  <p>Estamos validando tu sesión, por favor espera.</p>
</section>
} @else {
<main class="max-w-4xl mx-auto p-4 sm:p-8 flex flex-col gap-4">
  <router-outlet />
</main>
}

<app-global-loader />
